import { Accordion } from "@szhsin/react-accordion";
import { AccordionItem } from "../Shared/AccordionItem";
import Pattern from "../../assets/HeadingSectionPattern.svg"
import { useQuery } from "@tanstack/react-query";
import { getFAQ } from "../../api/FAQs/GetAllFAQ";
import Spinner from "../Shared/Spinner";

const FAQsSection = () => {
    const { data: FaqResponse, isLoading: isFaqLoading } = useQuery({
        queryFn: getFAQ,
        queryKey: ["faqs"],
        staleTime: 0,
        refetchInterval: 0,
      });
      const faqData = FaqResponse?.data?.faqData || [];
    
    const transformYoutubeLink = (url: string) => {
        if (url !== '') {
            const transformedUrl = url.replace('watch?v=', 'embed/');
            return transformedUrl;
        } else {
            return '';
        }
    };
    
    return (
        <>
            <div className="bg-[#c7461f] relative md:mt-20 mt-[60px] min-h-[435px]">
                <img src={Pattern} className="absolute w-full h-full object-cover" alt="" />
                <div className="container z-50 relative h-full flex lg:flex-row flex-col items-center py-12 lg:gap-0 md:gap-10 gap-6">
                    <div className="lg:w-[60%] w-full">
                        <h1 className="text-white font-semibold lg:text-start text-center lg:text-5xl md:text-4xl sm:text-3xl text-2xl lg:mb-14 mb-7">
                            How can we<br />
                            help you today?
                        </h1>
                    </div>
                    <div className="bg-white rounded-xl md:px-6 px-3 md:py-9 py-5 lg:w-[40%] w-full min-h-80">
                        <h1 className="mb-3 text-primary sm:text-[28px] text-2xl font-semibold">Recent Questions</h1>
                        {faqData.slice(0, 2).map((faq, index) => ( // Updated to map over the first two questions
        <div className="space-y-1" key={index}>
            <h1 className="font-medium text-textPrimary sm:text-base text-sm">{faq.question}</h1>
            <p className="sm:text-sm text-xs">{faq.answer}</p>
        </div>
    ))}
                    </div>
                </div>
            </div>
            <div className="sm:pt-28 pt-14 sm:pb-24 pb-12 relative">
            {isFaqLoading ? (
            <div className="min-h-[50vh] flex justify-center items-center">
              <Spinner />
            </div>
          ) : (

                <div className="max-w-[944px] px-5 mx-auto relative z-50">
                    <Accordion className="sm:space-y-8 space-y-3" transition transitionTimeout={200}>
                        {faqData.map((faq, index) => (
                            <AccordionItem
                                key={index}
                                header={faq.question}
                                video={faq.video ? transformYoutubeLink(faq.video) : ''}
                            >
                                {faq.answer}
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            )}
            </div>
        </>
    )
}

export default FAQsSection